import React from 'react'
import Box from '@material-ui/core/Box'
import { BlueButton } from '../Components/Buttons'
import Styles from '../Styles/Styles'
import Wrapper from "../Components/Wrapper";

function NoISNFound() {
    const classes = Styles({});

    return (
        <Wrapper>
            <Box className={classes.logoContainer}><img width="140" alt="ISN" src={process.env.REACT_APP_ISN_LOGO} /></Box>
            <p className={classes.info}>Sorry, we were unable to locate your company key with that email address. Try another email address or contact ISN Support for help.</p>
            <Box className={classes.inputBox}>
                <BlueButton href={process.env.REACT_APP_FIND_ISN_CONTACT} fullWidth className={classes.button}>
                    CONTACT ISN SUPPORT
                </BlueButton>
            </Box>
            <Box className={classes.linkBox}>
                <a href="/" className={classes.link}>TRY WITH DIFFERENT EMAIL</a>
            </Box>
        </Wrapper>
    );
};

export default NoISNFound